import * as React from "react";
import omit from "lodash/omit";

function SvgComponent(props) {
  const {
    backcolor = "#fff",
    glutescolor = "#fff",
    abductorscolor = "#fff",
    adductorscolor = "#fff",
    calvescolor = "#fff",
    quadricepscolor = "#fff",
    hamstringscolor = "#fff",
    forearmscolor = "#fff",
    tricepscolor = "#fff",
    bicepscolor = "#fff",
    abscolor = "#fff",
    chestcolor = "#fff",
    shoulderscolor = "#fff",
  } = props;
  const customProps = [
    backcolor,
    glutescolor,
    abductorscolor,
    adductorscolor,
    calvescolor,
    quadricepscolor,
    hamstringscolor,
    forearmscolor,
    tricepscolor,
    bicepscolor,
    abscolor,
    chestcolor,
    shoulderscolor,
  ];
  const originalWidth = 100;
  // const originalHeight = 92.669;
  const originalHeight = 100;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={"100%"}
      height={"100%"}
      viewBox={`0 0 ${originalWidth} ${originalHeight}`}
      {...omit(props, customProps)}
    >
      <g fill="#fff">
        <path
          data-name="Path 156"
          d="M42.735 42.999c-.183.091-.137 1.347-.131 1.787s.692 3.017 1.327 2.921a1.292 1.292 0 001-.827c.122-.265.913-.748 1.028-.995a6.932 6.932 0 00-1.325-2.32c-.217-.13-.365-.641-.73-.763a4.058 4.058 0 00-1.169.197z"
        />
        <path
          data-name="Path 157"
          d="M44.734 43.157c-.024-.159.279-.279.389-.228s1.825 1.042 2 1.185c.548.447 1.769.871 1.694 1.121-.173.57-1.577.183-2.178-.312s-1.841-1.337-1.905-1.766z"
        />
        <path
          data-name="Path 158"
          d="M46.335 46.259c-.139.024-.394.082-.365.4a17.439 17.439 0 001.38 3.149c.25.254.411-.042.332-.476a14.423 14.423 0 00-1.347-3.073z"
        />
        <path
          data-name="Path 159"
          d="M45.598 46.934a1.214 1.214 0 00-.332.476 17 17 0 001.511 3.651c.206.082.38-.1.365-.414a20.488 20.488 0 00-1.544-3.713z"
        />
        <path
          data-name="Path 160"
          d="M44.929 47.614a.449.449 0 00-.3.383c-.016.192.925 3.012 1.38 2.935s-.02-.9-.082-1.077a19.511 19.511 0 00-.998-2.241z"
        />
        <path
          data-name="Path 161"
          d="M43.659 48.028c-.026-.161.414.153.5.316a6.553 6.553 0 01.548 1.756c-.482.154-.933-1.359-1.048-2.072z"
        />
        <path
          data-name="Path 167"
          d="M36.673 31.336a.148.148 0 01-.088-.013 8.887 8.887 0 01-2.921-2.63l-.069-.089a2.794 2.794 0 01-.183-.955.159.159 0 01.223.026l.071.093c.414.531 1.721 2.678 3.01 3.267a.159.159 0 01.078.21.155.155 0 01-.121.091z"
        />
        <path
          data-name="Path 197"
          d="M28.073 86.113c.235-.035.29 1.026.3 1.46s.451 1.145.217 1.426-.9.67-1.287 1.15-.933 1.442-.977 1.084a7.536 7.536 0 01.009-2.3c.191-.399.828-2.69 1.738-2.82z"
        />
        <path
          data-name="Path 198"
          d="M28.919 89.629a23.817 23.817 0 011.758 2.519c.005.318-2.148.4-2.384.4s-.25 0-.458-.639a2 2 0 01-.058-1.46c.157-.154 1.064-.975 1.142-.82z"
        />
        <path
          data-name="Path 199"
          d="M27.148 90.814c-.208.044-.584.761-.582 1s-.068.65.131.646.8.183.831-.208.016-1.528-.38-1.438z"
        />
        <path
          data-name="Path 200"
          d="M26.69 85.161c.135-.082.575-.453.82-.6s.495.5.29.648a16.212 16.212 0 00-1.2 2.132 4.981 4.981 0 01.09-2.18z"
        />
        <path
          data-name="Path 207"
          d="M26.782 63.198c.057 2.658 1.493 4.207 1.081 7.23.001-1.79-1.897-2.69-1.081-7.23z"
        />
        <path
          data-name="Path 208"
          d="M30.666 61.739c.086-.349-.385 3.669-.374 4.029s-1.137.675-1.442 1.073a5.937 5.937 0 01.268-1.331 24.124 24.124 0 001.548-3.771z"
        />
        <path
          data-name="Path 209"
          d="M27.409 63.957c0-.5.425-.668.913-.674s.831.148.838.652c0 .423-.9 2.6-1.059 2.373a7.5 7.5 0 01-.564-1.805 1.572 1.572 0 01-.128-.546z"
        />
        <path
          data-name="Path 210"
          d="M6.083 42.999c.183.091.137 1.347.13 1.787s-.69 3.017-1.325 2.921a1.291 1.291 0 01-1-.827c-.122-.265-.913-.748-1.028-.995a6.9 6.9 0 011.325-2.32c.219-.13.354-.641.73-.763a4.069 4.069 0 011.168.197z"
        />
        <path
          data-name="Path 211"
          d="M4.085 43.157c.024-.159-.281-.279-.391-.228s-1.825 1.042-2 1.185c-.548.447-1.771.871-1.694 1.121.172.57 1.575.183 2.176-.312s1.84-1.337 1.909-1.766z"
        />
        <path
          data-name="Path 212"
          d="M2.482 46.259c.139.024.4.082.365.4a17.1 17.1 0 01-1.387 3.149c-.257.254-.413-.042-.332-.476a14.592 14.592 0 011.354-3.073z"
        />
        <path
          data-name="Path 213"
          d="M3.22 46.934a1.177 1.177 0 01.332.476 16.9 16.9 0 01-1.51 3.651c-.206.082-.38-.1-.365-.414a21.167 21.167 0 011.543-3.713z"
        />
        <path
          data-name="Path 214"
          d="M3.888 47.614a.449.449 0 01.3.383c.016.192-.925 3.012-1.378 2.935s.02-.9.082-1.077a19.523 19.523 0 01.996-2.241z"
        />
        <path
          data-name="Path 215"
          d="M5.163 48.028c.026-.161-.413.153-.5.316a6.488 6.488 0 00-.548 1.756c.478.154.93-1.359 1.048-2.072z"
        />
        <path
          data-name="Path 217"
          d="M12.144 31.336a.146.146 0 00.088-.013 8.887 8.887 0 002.921-2.63l.071-.089a2.8 2.8 0 00.183-.955.161.161 0 00-.225.026l-.071.093c-.414.526-1.719 2.678-3.01 3.264a.159.159 0 00.044.3z"
        />
        <path
          data-name="Path 231"
          d="M20.745 86.113c-.235-.035-.292 1.026-.3 1.46s-.451 1.145-.217 1.426.9.67 1.278 1.15.933 1.442.977 1.084a7.831 7.831 0 000-2.3c-.179-.399-.827-2.69-1.738-2.82z"
        />
        <path
          data-name="Path 232"
          d="M19.896 89.629a23.531 23.531 0 00-1.756 2.519c0 .318 2.15.4 2.389.4s.25 0 .456-.639a2.023 2.023 0 00.06-1.46c-.154-.154-1.065-.975-1.149-.82z"
        />
        <path
          data-name="Path 233"
          d="M21.671 90.814c.208.044.584.761.58 1s.068.65-.13.646-.8.183-.831-.208-.016-1.528.381-1.438z"
        />
        <path
          data-name="Path 234"
          d="M22.129 85.161c-.137-.082-.575-.453-.82-.6s-.5.5-.29.648a16.008 16.008 0 011.2 2.132 5.009 5.009 0 00-.09-2.18z"
        />
        <path
          data-name="Path 235"
          d="M22.037 63.198c-.057 2.658-1.493 4.207-1.082 7.23 0-1.79 1.898-2.69 1.082-7.23z"
        />
        <path
          data-name="Path 236"
          d="M18.155 61.739c-.086-.349.383 3.669.374 4.029s1.137.675 1.442 1.073a5.939 5.939 0 00-.27-1.331 23.811 23.811 0 01-1.546-3.771z"
        />
        <path
          data-name="Path 237"
          d="M21.41 63.957c0-.5-.425-.668-.913-.674s-.831.148-.838.652c0 .423.9 2.6 1.059 2.373a7.421 7.421 0 00.564-1.805 1.614 1.614 0 00.128-.546z"
        />
        <path
          data-name="Path 240"
          d="M26.833 11.732c.237 0 .08 1.508.04 1.785s-1.783 3.49-1.9 3.727-.318-1.427-.119-1.745 1.817-3.767 1.979-3.767z"
        />
        <path
          data-name="Path 241"
          d="M21.926 11.732c-.239 0-.08 1.508-.04 1.785s1.783 3.49 1.9 3.727.318-1.427.119-1.745-1.821-3.767-1.979-3.767z"
        />
        <path
          data-name="Path 242"
          d="M25.323 12.498a5.206 5.206 0 01-1.709.02c-.4-.1.845 3.12.845 3.12l.009-.051v.031s1.231-3.202.855-3.12z"
        />
        <path
          data-name="Path 243"
          d="M28.388 6.317c.053-.345.1-.7.115-1.055a6.765 6.765 0 00-.575-2.86A5.084 5.084 0 0025.695.23a5.721 5.721 0 00-2.647 0 5 5 0 00-2.231 2.172 6.736 6.736 0 00-.559 2.86 10.77 10.77 0 00.128 1.139c-.254.053-.664.285-.6.476.091.267.661 2.409.858 2.11a.515.515 0 00.051-.183 7.193 7.193 0 00.365 2.008 5.374 5.374 0 001.825 1.03c.281.057 1.082.292 1.446.334h.1c.365-.042 1.186-.281 1.446-.334a5.467 5.467 0 001.825-1.03 7.654 7.654 0 00.365-2.059.491.491 0 00.047.153c.2.3.767-1.844.858-2.108.065-.196-.329-.422-.584-.481z"
        />
        <path
          data-name="Path 248"
          d="M74.84 17.426c-.423-.635-4.5-2.3-7.959-1.48 4.2.026 3.18 7.63 8.019 9.857.257-1.448.286-7.844-.06-8.377z"
        />
        <path
          data-name="Path 250"
          d="M68.988 18.115c-.528.026-2.855 3.067-2.618 3.516s3.967.873 4.363.847-1.128-4.394-1.745-4.363z"
        />
        <path
          data-name="Path 263"
          d="M73.034 88.981c0-.422.925 3.172.4 3.49a6.876 6.876 0 01-2.935.08c-.635-.1 1.11-3.967 1.11-3.967s-.714 3.331.548 3.41c.322.021.877-2.274.877-3.013z"
        />
        <path
          data-name="Path 264"
          d="M73.217 9.949a3.689 3.689 0 01.818-1.349 8.139 8.139 0 01-.263 2.776c-.212.449-.608 1.006-.635 1.084s.027-2.092.08-2.511z"
        />
        <path
          data-name="Path 265"
          d="M78.125 9.949a3.667 3.667 0 00-.82-1.349 8.1 8.1 0 00.265 2.776c.212.449.608 1.006.635 1.084s-.023-2.092-.08-2.511z"
        />
        <path
          data-name="Path 266"
          d="M79.653 5.79c.082-1.725.106-3-.995-4.443A3.767 3.767 0 0075.582.004a3.683 3.683 0 00-3.03 1.34c-1.117 1.46-1.073 2.762-.989 4.534-.217-.022-.823.27-.741.507.095.276.686 2.5.891 2.19a.8.8 0 00.069-.343c.161 1.2.557 2.26.613 2.652.089.624.425-3.567 2.738-3.651h.933c2.32.089 2.656 4.28 2.738 3.651.055-.389.447-1.435.608-2.619a.586.586 0 00.058.221c.2.31.8-1.917.891-2.19.093-.226-.474-.507-.708-.506z"
        />
        <path
          data-name="Path 267"
          d="M79.653 5.79c.082-1.725.106-3-.995-4.443A3.767 3.767 0 0075.582.004a3.683 3.683 0 00-3.03 1.34c-1.117 1.46-1.073 2.762-.989 4.534-.217-.022-.823.27-.741.507.095.276.686 2.5.891 2.19a.8.8 0 00.069-.343c.161 1.2.557 2.26.613 2.652.089.624.425-3.567 2.738-3.651h.933c2.32.089 2.656 4.28 2.738 3.651.055-.389.447-1.435.608-2.619a.586.586 0 00.058.221c.2.31.8-1.917.891-2.19.093-.226-.474-.507-.708-.506z"
        />
        <path
          data-name="Path 268"
          d="M76.147 17.426c.423-.635 4.5-2.3 7.959-1.48-4.2.026-3.18 7.63-8.021 9.857-.265-1.448-.294-7.844.062-8.377z"
        />
        <path
          data-name="Path 270"
          d="M81.99 18.115c.529.026 2.857 3.067 2.618 3.516s-3.965.873-4.363.847 1.128-4.394 1.745-4.363z"
        />
        <path
          data-name="Path 277"
          d="M87.107 30.704c-.307.082-1.294.1 1.491 2.837.256.25.006-3.237-1.491-2.837z"
        />
        <path
          data-name="Path 291"
          d="M77.943 88.981c0-.422-.925 3.172-.4 3.49a6.877 6.877 0 002.935.08c.635-.1-1.112-3.967-1.112-3.967s.716 3.331-.548 3.41c-.318.021-.875-2.274-.875-3.013z"
        />
        <path
          data-name="Path 292"
          d="M93.85 42.799c-.182.091-.139 1.347-.131 1.787s.69 3.017 1.325 2.921a1.3 1.3 0 001-.827c.12-.265.913-.748 1.028-.995a6.906 6.906 0 00-1.327-2.32c-.219-.13-.354-.641-.73-.765a4.121 4.121 0 00-1.165.199z"
        />
        <path
          data-name="Path 293"
          d="M95.915 43.22c-.024-.161.279-.279.389-.228s1.825 1.04 2 1.185c.548.447 1.771.869 1.7 1.119-.182.571-1.577.183-2.178-.31s-1.849-1.335-1.911-1.766z"
        />
        <path
          data-name="Path 294"
          d="M97.451 46.059c-.139.024-.4.082-.365.4a17.561 17.561 0 001.378 3.149c.25.254.413-.042.332-.476a14.615 14.615 0 00-1.345-3.073z"
        />
        <path
          data-name="Path 295"
          d="M96.712 46.733a1.178 1.178 0 00-.332.476 16.816 16.816 0 001.511 3.651c.208.082.378-.106.365-.416a20.392 20.392 0 00-1.544-3.711z"
        />
        <path
          data-name="Path 296"
          d="M96.041 47.417a.444.444 0 00-.3.382c-.016.192.925 3.012 1.378 2.935s-.02-.9-.082-1.077a19.345 19.345 0 00-.996-2.24z"
        />
        <path
          data-name="Path 297"
          d="M94.774 47.827c-.026-.161.414.153.5.316a6.553 6.553 0 01.548 1.756c-.482.156-.935-1.359-1.048-2.072z"
        />
        <path
          data-name="Path 299"
          d="M63.947 30.704c.307.082 1.3.1-1.491 2.837-.254.25-.005-3.237 1.491-2.837z"
        />
        <path
          data-name="Path 302"
          d="M57.113 42.799c.183.091.137 1.347.13 1.787s-.69 3.017-1.325 2.921a1.3 1.3 0 01-1-.827c-.12-.265-.913-.748-1.026-.995a6.932 6.932 0 011.325-2.32c.219-.13.356-.641.73-.765a4.144 4.144 0 011.166.199z"
        />
        <path
          data-name="Path 303"
          d="M55.047 43.22c.024-.161-.279-.279-.389-.228s-1.825 1.04-2 1.185c-.548.447-1.771.869-1.694 1.119.172.571 1.575.183 2.176-.31s1.845-1.335 1.907-1.766z"
        />
        <path
          data-name="Path 304"
          d="M53.513 46.059c.139.024.4.082.365.4a17.559 17.559 0 01-1.378 3.149c-.25.254-.411-.042-.332-.476a14.521 14.521 0 011.345-3.073z"
        />
        <path
          data-name="Path 305"
          d="M54.25 46.733a1.177 1.177 0 01.332.476 16.9 16.9 0 01-1.51 3.651c-.206.082-.38-.106-.365-.416a20.657 20.657 0 011.543-3.711z"
        />
        <path
          data-name="Path 306"
          d="M54.917 47.417a.444.444 0 01.3.382c.018.192-.925 3.012-1.378 2.935s.02-.9.082-1.077a19.345 19.345 0 01.996-2.24z"
        />
        <path
          data-name="Path 307"
          d="M56.188 47.827c.027-.161-.413.153-.5.316a6.488 6.488 0 00-.548 1.756c.482.156.934-1.359 1.048-2.072z"
        />
        <g data-name="Upper back">
          <path
            data-name="Path 172"
            d="M27.337 13.674a12.891 12.891 0 013.371 1.745c.268.285-1.586.365-1.745.365a7.345 7.345 0 01-1.626-1.427c-.199-.318-.278-.683 0-.683z"
          />
          <path
            data-name="Path 173"
            d="M26.863 14.904c.152.3.792.953.436 1.112s-.953.119-.953-.04.436-1.23.517-1.072z"
          />
          <path
            data-name="Path 238"
            d="M21.242 13.674a12.919 12.919 0 00-3.371 1.745c-.268.285 1.586.365 1.745.365a7.3 7.3 0 001.626-1.427c.197-.318.279-.683 0-.683z"
          />
          <path
            data-name="Path 239"
            d="M21.722 14.904c-.152.3-.794.953-.436 1.112s.951.119.951-.04-.439-1.23-.515-1.072z"
          />
          <path
            data-name="Path 246"
            d="M76.382 8.218a8.842 8.842 0 00.686 3.1 14.684 14.684 0 004.416 3.78 17.445 17.445 0 00-5.051 1.32c-.106-1.8-.318-7.139-.58-8.032a.929.929 0 00.529-.168z"
          />
          <path
            data-name="Path 247"
            d="M74.964 8.218a8.883 8.883 0 01-.686 3.1 14.684 14.684 0 01-4.416 3.78 17.424 17.424 0 015.049 1.322c.106-1.8.319-7.139.582-8.032a.929.929 0 01-.529-.17z"
          />
        </g>
        <g data-name="Back">
          <path
            data-name="Path 179"
            d="M29.695 30.123s-.12 1.269.038 1.427 1.23-.752 1.309-.991.611-2.294.294-1.9a3.2 3.2 0 01-1.641 1.464z"
            fill={backcolor}
          />
          <path
            data-name="Path 180"
            d="M29.865 27.75c-.04.318-.2 1.349 0 1.387s1.19-1.376 1.309-1.692.053-.577-.066-.5-1.205.478-1.243.805z"
            fill={backcolor}
          />
          <path
            data-name="Path 181"
            d="M29.582 25.827c-.106.214-.314 1.278.162 1.2s1.5-1.219 1.446-1.581c-.065-.414-1.527.223-1.608.381z"
            fill={backcolor}
          />
          <path
            data-name="Path 182"
            d="M28.923 24.282c-.228.226.2 1.031.462.955s1.971-1.03 1.855-1.493c-.099-.404-2.264.485-2.317.538z"
            fill={backcolor}
          />
          <path
            data-name="Path 183"
            d="M32.749 22.728a9.054 9.054 0 00-1.112 2.9c0 .318-.06 2.986.232 2.669a4.169 4.169 0 00.7-2.32c.071-1.331.063-2.104.18-3.249z"
            fill={backcolor}
          />
          <path
            data-name="Path 184"
            d="M19.179 30.123s.12 1.269-.038 1.427-1.23-.752-1.309-.991-.61-2.294-.294-1.9a3.193 3.193 0 001.641 1.464z"
            fill={backcolor}
          />
          <path
            data-name="Path 185"
            d="M19.013 27.75c.04.318.2 1.349 0 1.387s-1.19-1.387-1.307-1.7-.053-.577.068-.5 1.209.486 1.239.813z"
            fill={backcolor}
          />
          <path
            data-name="Path 186"
            d="M19.298 25.827c.106.214.314 1.278-.162 1.2s-1.5-1.219-1.446-1.581c.064-.414 1.526.223 1.608.381z"
            fill={backcolor}
          />
          <path
            data-name="Path 187"
            d="M19.955 24.282c.228.226-.2 1.031-.462.955-.23-.068-1.971-1.03-1.855-1.493.101-.404 2.259.485 2.317.538z"
            fill={backcolor}
          />
          <path
            data-name="Path 188"
            d="M16.131 22.728a9.089 9.089 0 011.11 2.9c0 .318.06 2.986-.232 2.669a4.169 4.169 0 01-.7-2.32c-.063-1.331-.063-2.104-.178-3.249z"
            fill={backcolor}
          />
          <path
            data-name="Path 272"
            d="M74.755 26.682a25.232 25.232 0 01-3.7-3.2c-1.015-.639-1.548-.29-4.363-.794-.215 5.633 3.992 7.9 4.514 12.412 1.261-.658 4.102-3.979 3.549-8.418z"
            fill={backcolor}
          />
          <path
            data-name="Path 311"
            d="M75.989 26.682a25.134 25.134 0 003.7-3.2c1.015-.639 1.548-.29 4.363-.794.215 5.633-3.992 7.9-4.514 12.412-1.266-.658-4.102-3.979-3.549-8.418z"
            fill={backcolor}
          />
        </g>
        <g data-name="Shoulders">
          <path
            data-name="Path 162"
            d="M32.48 15.839a3.878 3.878 0 012.935.991c.706.63 1.031 2.776.714 4.443a10.849 10.849 0 00-3.649-5.434z"
            fill={shoulderscolor}
          />
          <path
            data-name="Path 163"
            d="M30.737 16.157c1.7.239 4.64 3.371 4.877 5.514-2.378-.04-4.799-3.413-4.877-5.514z"
            fill={shoulderscolor}
          />
          <path
            data-name="Path 201"
            d="M16.391 15.839a3.878 3.878 0 00-2.935.991c-.706.63-1.031 2.776-.714 4.443a10.861 10.861 0 013.649-5.434z"
            fill={shoulderscolor}
          />
          <path
            data-name="Path 202"
            d="M18.137 16.157c-1.709.239-4.642 3.379-4.879 5.51 2.38-.036 4.799-3.409 4.879-5.51z"
            fill={shoulderscolor}
          />
          <path
            data-name="Path 249"
            d="M68.697 17.242c-1.48 1.957-4.2 4.97-4.547 5.023a4.835 4.835 0 01.343-4.706c.999-1.311 3.41-1.005 4.204-.317z"
            fill={shoulderscolor}
          />
          <path
            data-name="Path 269"
            d="M82.282 17.242c1.48 1.957 4.2 4.97 4.547 5.023a4.835 4.835 0 00-.343-4.706c-.999-1.311-3.412-1.005-4.204-.317z"
            fill={shoulderscolor}
          />
        </g>
        <g data-name="Chest">
          <path
            data-name="Path 164"
            d="M24.897 17.821a3.79 3.79 0 014.22-.807c2.265 1.04 3.468 4.978 3.434 5.067-.04.122-3.926 2.353-5.83 2.353-1.112 0-1.944-.611-1.944-.938s-.119-5.512.12-5.675z"
            fill={chestcolor}
          />
          <path
            data-name="Path 165"
            d="M23.848 17.821a3.791 3.791 0 00-4.22-.807c-2.267 1.04-3.468 4.978-3.434 5.067.04.122 3.926 2.353 5.83 2.353 1.11 0 1.942-.611 1.942-.938s.129-5.512-.118-5.675z"
            fill={chestcolor}
          />
        </g>
        <g data-name="Forearms">
          <path
            data-name="Path 168"
            d="M37.373 30.67a6.235 6.235 0 00.993 3.446c.3 1.035 2.395 3.711 3 4.563.7.995 1.473 2.921 1.707 2.955s-1.364-3.171-1.48-3.468c-.487-1.268-1.546-6.218-4.22-7.496z"
            fill={forearmscolor}
          />
          <path
            data-name="Path 169"
            d="M35.846 31.992c.226 0 2.6 2.72 2.568 3.233s-1.1-.365-1.754-.708-1.006-.365-.995-.591-.144-1.923.181-1.934z"
            fill={forearmscolor}
          />
          <path
            data-name="Path 170"
            d="M37.542 35.577c1.583.133 5.043 5.921 5.1 6.36-.708-.935-3.067-3.569-3.26-3.817-.391-.499-1.51-1.997-1.84-2.543z"
            fill={forearmscolor}
          />
          <path
            data-name="Path 171"
            d="M36.528 35.478l.057.082c.04.051.082.141.161.232s.159.2.252.334.221.266.338.429c.235.327.548.677.843 1.079.144.208.316.4.473.611s.321.427.5.626c.365.387.694.81 1.055 1.145l.511.5a4.989 4.989 0 00.467.433c.608.5 1.1.977 1.1.977a.022.022 0 010 .029c0 .011-.071 0-.027 0 0 0-.517-.444-1.159-.887a5.8 5.8 0 01-.5-.394l-.548-.464c-.382-.318-.741-.721-1.126-1.1-.192-.183-.365-.4-.548-.591a5.7 5.7 0 01-.511-.6 11.6 11.6 0 01-.785-1.17 7.945 7.945 0 01-.471-.913 2.59 2.59 0 01-.128-.365.022.022 0 01.013-.027.026.026 0 11.042.029z"
            fill={forearmscolor}
          />
          <path
            data-name="Path 218"
            d="M11.447 30.67a6.235 6.235 0 01-.993 3.446c-.3 1.035-2.395 3.711-3 4.563-.7.995-1.473 2.921-1.707 2.955s1.362-3.171 1.479-3.468c.488-1.268 1.545-6.218 4.221-7.496z"
            fill={forearmscolor}
          />
          <path
            data-name="Path 219"
            d="M12.971 31.992c-.226 0-2.594 2.72-2.568 3.233s1.1-.365 1.756-.708 1.006-.365.995-.591.142-1.923-.183-1.934z"
            fill={forearmscolor}
          />
          <path
            data-name="Path 220"
            d="M11.277 35.577c-1.583.133-5.045 5.921-5.1 6.36.706-.935 3.065-3.569 3.26-3.817.391-.499 1.515-1.997 1.84-2.543z"
            fill={forearmscolor}
          />
          <path
            data-name="Path 221"
            d="M12.29 35.478s-.018.029-.055.082a2.323 2.323 0 01-.161.232c-.077.091-.161.2-.254.334s-.221.266-.338.429c-.234.327-.548.677-.843 1.079-.142.208-.316.4-.473.611a7.571 7.571 0 01-.493.626c-.365.387-.7.81-1.055 1.145l-.511.5a5.229 5.229 0 01-.467.433c-.608.5-1.1.977-1.1.977a.024.024 0 000 .029c0 .011.073 0 .027 0 0 0 .517-.444 1.161-.887a5.52 5.52 0 00.48-.387l.548-.464c.383-.318.741-.721 1.128-1.1.183-.183.365-.4.548-.591a5.468 5.468 0 00.509-.6 11.959 11.959 0 00.787-1.17 7.6 7.6 0 00.469-.913 2.808 2.808 0 00.13-.365.024.024 0 00-.015-.027.022.022 0 00-.027.022z"
            fill={forearmscolor}
          />
          <path
            data-name="Path 276"
            d="M86.17 33.162c-.084-.42.685.447 1.592.352s3.076 6.179 3.6 7.042c-.979-.257-5.022-6.575-5.192-7.394z"
            fill={forearmscolor}
          />
          <path
            data-name="Path 278"
            d="M89.536 32.172a13.933 13.933 0 002.921 8.647c.089-2.601-1.999-6.316-2.921-8.647z"
            fill={forearmscolor}
          />
          <path
            data-name="Path 279"
            d="M90.173 31.747c.325-.4 3.76 9.547 3.89 10.012s-.686.874-.8.566a68.464 68.464 0 00-3.09-10.578z"
            fill={forearmscolor}
          />
          <path
            data-name="Path 298"
            d="M64.889 33.162c.086-.42-.685.447-1.592.352s-3.076 6.179-3.605 7.042c.983-.257 5.03-6.575 5.197-7.394z"
            fill={forearmscolor}
          />
          <path
            data-name="Path 300"
            d="M61.514 32.172a13.934 13.934 0 01-2.921 8.647c-.076-2.601 2.01-6.316 2.921-8.647z"
            fill={forearmscolor}
          />
          <path
            data-name="Path 301"
            d="M60.887 31.747c-.327-.4-3.762 9.547-3.89 10.012s.685.874.8.566a68.115 68.115 0 013.09-10.578z"
            fill={forearmscolor}
          />
        </g>
        <g data-name="Abs">
          <path
            data-name="Path 174"
            d="M25.263 25.012c-.478.075-.08 1.586-.04 1.783s2.579.2 3.014.993.12-.874.12-1.19a2.789 2.789 0 00-3.094-1.586z"
            fill={abscolor}
          />
          <path
            data-name="Path 175"
            d="M25.144 27.859c-.232.055 0 1.984.159 2.618.042.172 2.738-.2 2.933.365a3.8 3.8 0 00.239-1.309 2.97 2.97 0 00-3.331-1.674z"
            fill={abscolor}
          />
          <path
            data-name="Path 176"
            d="M25.223 31.745a10.375 10.375 0 00-.04 2.7c.038.159.913-.356 1.309-.4s1.745.078 1.906-.159a2.545 2.545 0 00-.08-1.866c-.318-.403-2.341-1.029-3.095-.275z"
            fill={abscolor}
          />
          <path
            data-name="Path 177"
            d="M26.492 35.078c-.365.288-.991.515-1.11 1.07s-.19 5.91-.19 6.31a.73.73 0 00.754.754c.476 0 .953-1.19 1.15-1.825s.635-2.537.716-3.092.714-3.134.356-3.371a1.818 1.818 0 00-1.676.154z"
            fill={abscolor}
          />
          <path
            data-name="Path 178"
            d="M29.127 33.57c-.027.475-.248 5.275-.341 5.671s.093.674.312.635 1.294-.308 1.356-.745-.068-3.1-.068-3.627a19.005 19.005 0 00-.124-3.132c-.154-.118-1.102.682-1.135 1.198z"
            fill={abscolor}
          />
          <path
            data-name="Path 203"
            d="M23.611 25.012c.478.075.078 1.586.038 1.783s-2.577.2-3.014.993-.119-.874-.119-1.19a2.787 2.787 0 013.095-1.586z"
            fill={abscolor}
          />
          <path
            data-name="Path 204"
            d="M23.73 27.859c.232.055 0 1.984-.159 2.618-.044.172-2.738-.2-2.935.365a3.8 3.8 0 01-.239-1.309 2.972 2.972 0 013.333-1.674z"
            fill={abscolor}
          />
          <path
            data-name="Path 205"
            d="M23.649 31.745a10.3 10.3 0 01.04 2.7c-.04.159-.913-.356-1.309-.4s-1.745.078-1.9-.159a2.562 2.562 0 01.078-1.866c.313-.403 2.337-1.029 3.091-.275z"
            fill={abscolor}
          />
          <path
            data-name="Path 206"
            d="M22.381 35.078c.365.288.991.515 1.11 1.07s.2 5.911.2 6.307a.73.73 0 01-.754.754c-.476 0-.951-1.19-1.15-1.825s-.635-2.537-.714-3.092-.714-3.134-.365-3.371a1.819 1.819 0 011.673.157z"
            fill={abscolor}
          />
          <path
            data-name="Path 222"
            d="M19.69 33.57c.029.475.248 5.275.343 5.671s-.095.674-.312.635-1.294-.308-1.358-.745.069-3.1.069-3.627a19 19 0 01.124-3.132c.156-.118 1.103.682 1.134 1.198z"
            fill={abscolor}
          />
          <path
            data-name="Path 273"
            d="M69.851 32.874c-.214-.022 0 3.4-.06 3.833s1.024-.493 1.207-.593-.809-3.21-1.147-3.24z"
            fill={abscolor}
          />
          <path
            data-name="Path 312"
            d="M80.891 32.874c.214-.022 0 3.4.06 3.833s-1.024-.493-1.207-.593.809-3.21 1.147-3.24z"
            fill={abscolor}
          />
        </g>
        <g data-name="Quadriceps">
          <path
            data-name="Path 190"
            d="M27.141 42.76c-.223.23-1.676 1.46-1.643 1.679a9.4 9.4 0 001.225 2.6c.312.193.257-1.223.56-2.008.325-.831 2.253-4.2 2.253-4.3a16.35 16.35 0 00-2.395 2.029z"
            fill={quadricepscolor}
          />
          <path
            data-name="Path 191"
            d="M30.436 40.377c.325 3.527-4.111 12.146-4.574 15.782-.249-10.562 3.868-12.429 4.574-15.782z"
            fill={quadricepscolor}
          />
          <path
            data-name="Path 192"
            d="M28.841 48.645c.447-.925 2.51-8.194 2.555-7.968 1.814 8.053-2.227 15.99-2.451 17.025a38.207 38.207 0 00-.13 4.39c-.037.277-.511.245-.674.009s-1.308-9.306.7-13.456z"
            fill={quadricepscolor}
          />
          <path
            data-name="Path 193"
            d="M32.052 47.412c-.471 3.032-2.19 9.3-2.442 10.512a22.688 22.688 0 00-.2 3.762c.007.555.131.951.33.949a31.572 31.572 0 001.984-5.5c.932-2.834.549-6.934.328-9.723z"
            fill={quadricepscolor}
          />
          <path
            data-name="Path 194"
            d="M27.125 53.121c.314-.183.02 4.038.068 4.593s.936 5.357-.137 5.213-.933-3.483-.946-4.474.74-5.173 1.015-5.332z"
            fill={quadricepscolor}
          />
          <path
            data-name="Path 224"
            d="M21.678 42.76c.223.23 1.674 1.46 1.643 1.679a9.4 9.4 0 01-1.225 2.6c-.312.193-.257-1.223-.56-2.008-.323-.831-2.252-4.2-2.251-4.3a16.8 16.8 0 012.393 2.029z"
            fill={quadricepscolor}
          />
          <path
            data-name="Path 225"
            d="M18.383 40.377c-.325 3.527 4.111 12.146 4.574 15.782.248-10.562-3.864-12.429-4.574-15.782z"
            fill={quadricepscolor}
          />
          <path
            data-name="Path 226"
            d="M19.975 48.645c-.447-.925-2.51-8.194-2.556-7.968-1.825 8.053 2.227 15.99 2.451 17.025a37.716 37.716 0 01.128 4.39c.035.277.513.245.675.009s1.304-9.306-.698-13.456z"
            fill={quadricepscolor}
          />
          <path
            data-name="Path 227"
            d="M16.766 47.412c.473 3.032 2.19 9.3 2.444 10.512a22.861 22.861 0 01.193 3.762c-.007.555-.131.951-.329.949a31.573 31.573 0 01-1.984-5.5c-.928-2.834-.545-6.934-.324-9.723z"
            fill={quadricepscolor}
          />
          <path
            data-name="Path 228"
            d="M21.696 53.121c-.316-.183-.02 4.038-.068 4.593s-.936 5.357.137 5.213.931-3.483.944-4.474-.739-5.173-1.013-5.332z"
            fill={quadricepscolor}
          />
        </g>
        <g data-name="Adductors">
          <path
            data-name="Path 189"
            d="M24.825 44.606a21.084 21.084 0 00.677 6.1c.533 1.183.345-.876.418-1.314s.7-1.159.414-1.672-1.473-3.192-1.509-3.114z"
            fill={adductorscolor}
          />
          <path
            data-name="Path 223"
            d="M23.996 44.606a21.213 21.213 0 01-.677 6.1c-.531 1.183-.345-.876-.418-1.314s-.7-1.159-.414-1.672 1.469-3.192 1.509-3.114z"
            fill={adductorscolor}
          />
        </g>
        <g data-name="Hamstrings">
          <path
            data-name="Path 256"
            d="M67.82 47.246a34.339 34.339 0 00.062 6.206c.265-1.269 1.028-2.921.816-3.446s-.666-3.182-.878-2.76z"
            fill={hamstringscolor}
          />
          <path
            data-name="Path 257"
            d="M70.923 49.046c-.183-.493-1.853 1.19-2.008 1.8a18.514 18.514 0 00-.27 8.223 21.572 21.572 0 01.456 5.374 15.886 15.886 0 01.977-4.29c-.955-2.048-.532-8.568.845-11.107z"
            fill={hamstringscolor}
          />
          <path
            data-name="Path 258"
            d="M71.605 48.177c.122.677-2.7 7.013-.869 12.23a14.321 14.321 0 001.552 3.165 8.661 8.661 0 010-3.538c.487-4.705-.186-10.988-.683-11.857z"
            fill={hamstringscolor}
          />
          <path
            data-name="Path 259"
            d="M74.515 46.56c-.053-.279-2.13 1.011-2.165 1.488-.183 2.545.978 4.456 1.241 10.238.172-4.847 2.047-5.765.924-11.726z"
            fill={hamstringscolor}
          />
          <path
            data-name="Path 260"
            d="M72.971 54.629c-.042-.433-.365 5.58-.307 6.109s-.062 4.092.183 3.632c1.055-1.985.497-5.772.124-9.741z"
            fill={hamstringscolor}
          />
          <path
            data-name="Path 280"
            d="M83.158 47.246a34.175 34.175 0 01-.062 6.206c-.265-1.269-1.026-2.921-.814-3.446s.664-3.182.876-2.76z"
            fill={hamstringscolor}
          />
          <path
            data-name="Path 281"
            d="M80.057 49.046c.183-.493 1.853 1.19 2.008 1.8a18.514 18.514 0 01.27 8.223 21.484 21.484 0 00-.456 5.374 15.959 15.959 0 00-.977-4.29c.953-2.048.529-8.568-.845-11.107z"
            fill={hamstringscolor}
          />
          <path
            data-name="Path 282"
            d="M79.375 48.177c-.124.677 2.7 7.013.869 12.23a14.4 14.4 0 01-1.552 3.165 8.661 8.661 0 000-3.538c-.487-4.705.186-10.988.683-11.857z"
            fill={hamstringscolor}
          />
          <path
            data-name="Path 283"
            d="M76.465 46.56c.053-.279 2.13 1.011 2.165 1.488.183 2.545-.978 4.456-1.241 10.238-.176-4.847-2.049-5.765-.924-11.726z"
            fill={hamstringscolor}
          />
          <path
            data-name="Path 284"
            d="M78.008 54.629c.04-.433.365 5.58.307 6.109s.062 4.092-.183 3.632c-1.055-1.985-.496-5.772-.124-9.741z"
            fill={hamstringscolor}
          />
        </g>
        <g data-name="calves">
          <path
            data-name="Path 195"
            d="M26.525 68.913a33.615 33.615 0 00-1.117 5.206c.038 2.466 1.418 8.36 1.426 8.917s.411-1.756.444-2.273 1.036-8.11-.753-11.85z"
            fill={calvescolor}
          />
          <path
            data-name="Path 196"
            d="M30.941 69.711a43.066 43.066 0 01-.265 4.574c-.192.518-1.807 6.555-1.882 6.913s-.988 3.225-1.035 2.671a10.863 10.863 0 01.566-2.19c.075-.4.88-5.447.991-6s1.625-5.968 1.625-5.968z"
            fill={calvescolor}
          />
          <path
            data-name="Path 229"
            d="M22.294 68.913a33.4 33.4 0 011.117 5.206c-.037 2.466-1.418 8.36-1.426 8.917s-.411-1.756-.444-2.273-1.037-8.11.753-11.85z"
            fill={calvescolor}
          />
          <path
            data-name="Path 230"
            d="M17.877 69.711a43.066 43.066 0 00.265 4.574c.192.518 1.807 6.555 1.88 6.913s.989 3.225 1.037 2.671a10.986 10.986 0 00-.566-2.19c-.073-.4-.88-5.447-.991-6s-1.625-5.968-1.625-5.968z"
            fill={calvescolor}
          />
          <path
            data-name="Path 244"
            d="M18.341 67.068a11.83 11.83 0 00.365 4.885c.489 1.515 1.249 4.578 1.473 5.573s1.188 6.124 1.263 6.562.469.52.436-.035-.794-2.946-.827-3.5-.528-5.8-.889-7.557c-.416-2.052-1.705-6.246-1.821-5.928z"
            fill={calvescolor}
          />
          <path
            data-name="Path 245"
            d="M30.512 67.068a11.8 11.8 0 01-.365 4.885c-.489 1.515-1.249 4.578-1.473 5.573s-1.188 6.124-1.261 6.562-.469.52-.438-.035.794-2.946.827-3.5.528-5.8.889-7.557c.411-2.052 1.704-6.246 1.821-5.928z"
            fill={calvescolor}
          />
          <path
            data-name="Path 261"
            d="M70.81 62.378c.038-.365-.633-.847-.741-.635s-1.322 8.225-1.322 9.335a11.131 11.131 0 001.8 4.151c.155-.047.847-.9.794-1.059a56.165 56.165 0 01-.531-11.792z"
            fill={calvescolor}
          />
          <path
            data-name="Path 262"
            d="M71.236 62.378c.106-.462 2.484 5.315 2.7 7.119s.423 6.108-.21 6.206-1.853-1.535-1.9-2.008c-.041-.294-.95-9.766-.59-11.317z"
            fill={calvescolor}
          />
          <path
            data-name="Path 285"
            d="M80.164 62.378c-.038-.365.635-.847.741-.635s1.322 8.225 1.322 9.335a11.131 11.131 0 01-1.8 4.151c-.155-.047-.845-.9-.792-1.059a56.075 56.075 0 00.529-11.792z"
            fill={calvescolor}
          />
          <path
            data-name="Path 286"
            d="M79.743 62.378c-.106-.462-2.486 5.315-2.7 7.119s-.423 6.108.212 6.206 1.851-1.535 1.9-2.008c.038-.294.945-9.766.588-11.317z"
            fill={calvescolor}
          />
          <path
            data-name="Path 287"
            d="M80.296 75.743c.285 0 .383-.095.5.529.423 2.344-1.853 3.609-2.008 11.171-.011.635-.429.562-.422.365a45.063 45.063 0 01.933-8.459c.201-.722.573-3.606.997-3.606z"
            fill={calvescolor}
          />
          <path
            data-name="Path 288"
            d="M77.278 77.034c-.071-.274-.318-1.783-.431-1.159-.423 2.342.708 4.038.856 11.6.013.633.183.089.172-.1-.137-4.147-.431-5.3-.464-7.953a9.867 9.867 0 00-.133-2.388z"
            fill={calvescolor}
          />
          <path
            data-name="Path 289"
            d="M70.541 75.743c-.285 0-.383-.095-.5.529-.423 2.344 1.853 3.609 2.008 11.171.013.635.429.562.422.365a45.06 45.06 0 00-.933-8.459c-.201-.722-.574-3.606-.997-3.606z"
            fill={calvescolor}
          />
          <path
            data-name="Path 290"
            d="M73.562 77.034c.071-.274.318-1.783.431-1.159.423 2.342-.708 4.038-.856 11.6-.013.633-.183.089-.172-.1.137-4.147.431-5.3.464-7.953a9.343 9.343 0 01.133-2.388z"
            fill={calvescolor}
          />
        </g>
        <g data-name="glutes">
          <path
            data-name="Path 253"
            d="M75.066 40.416c-.635-.318-6.409.016-6.924 3.468-.119.794.4 5.394.873 5.434.108-2.19 4.655-1.723 6.051-4.916a32.889 32.889 0 000-3.986z"
            fill={glutescolor}
          />
          <path
            data-name="Path 308"
            d="M74.537 32.07a34.173 34.173 0 01-2.791 3.758c-.557.462 2.437 3.421 2.716 3.928s.467-7.022.075-7.686z"
            fill={glutescolor}
          />
          <path
            data-name="Path 310"
            d="M75.675 40.416c.635-.318 6.409.016 6.924 3.468.119.794-.4 5.394-.873 5.434-.108-2.19-4.653-1.723-6.051-4.916a33.654 33.654 0 010-3.986z"
            fill={glutescolor}
          />
          <path
            data-name="Path 313"
            d="M76.205 32.07a34.173 34.173 0 002.791 3.758c.562.462-2.437 3.419-2.716 3.928s-.467-7.022-.075-7.686z"
            fill={glutescolor}
          />
        </g>
        <g data-name="Abductors">
          <path
            data-name="Path 252"
            d="M73.255 39.149a2.768 2.768 0 00-3.017-1.267c-.951.4-1.577 2.691-1.537 4.158.396-1.348 1.938-2.414 4.554-2.891z"
            fill={abductorscolor}
          />
          <path
            data-name="Path 309"
            d="M77.486 39.149a2.768 2.768 0 013.017-1.267c.951.4 1.577 2.691 1.537 4.158-.396-1.348-1.936-2.414-4.554-2.891z"
            fill={abductorscolor}
          />
        </g>
        <g data-name="biceps">
          <path
            data-name="Path 166"
            d="M33.587 22.014a4.219 4.219 0 012.287.615c1.628 1.342 1.491 4.268 1.491 5.022s.6 2.441-.434 2.441-3.344-3.556-3.574-4.627-.557-3.292.23-3.451z"
            fill={bicepscolor}
          />
          <path
            data-name="Path 216"
            d="M15.226 22.014a4.215 4.215 0 00-2.287.615c-1.628 1.342-1.491 4.268-1.491 5.022s-.6 2.441.433 2.441 3.346-3.556 3.583-4.627.554-3.292-.238-3.451z"
            fill={bicepscolor}
          />
        </g>
        <g data-name="triceps">
          <path
            data-name="Path 251"
            d="M66.185 21.288c-3.331 2.8-.792 7.378-1.48 9.6 3.702-3.545.825-8.014 1.48-9.6z"
            fill={tricepscolor}
          />
          <path
            data-name="Path 255"
            d="M63.977 25.678c-.119.356-1.03 4.6-.119 4.4.554-.277.119-4.4.119-4.4z"
            fill={tricepscolor}
          />
          <path
            data-name="Path 271"
            d="M84.793 21.288c3.331 2.8.792 7.378 1.48 9.6-3.701-3.545-.819-8.014-1.48-9.6z"
            fill={tricepscolor}
          />
          <path
            data-name="Path 275"
            d="M87 25.678c.119.356 1.031 4.6.119 4.4-.555-.277-.119-4.4-.119-4.4z"
            fill={tricepscolor}
          />
          <path
            data-name="Path 254"
            d="M64.136 23.058c-.6.318-1.942 4.125-1.46 7.141a36.429 36.429 0 011.46-7.141z"
            fill={tricepscolor}
          />
          <path
            data-name="Path 274"
            d="M86.842 23.058c.6.318 1.944 4.125 1.46 7.141a35.839 35.839 0 00-1.46-7.141z"
            fill={tricepscolor}
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgComponent;
